import {FooterStrapi} from '@web-catalog/types';

import {FooterProps} from '@packages/ui-kit/src/Footer/Footer.types';

import {
  onFooterClick,
  onSocialClick,
} from '@web-catalog/utils/analytics/footerAnalytics';

export const parseStrapiFooter = ({leftSideContent, links}: FooterStrapi) => {
  const socialLinks = leftSideContent?.webSocialLinks?.map((item) => ({
    href: item.href,
    logoHref: item.logoHref.data?.attributes.url,
    logoAlt: item.logoHref.data?.attributes.alternativeText || undefined,
    target: item.isTargetBlank ? '_blank' : '_self',
    onClick: onSocialClick,
  }));

  const parsedLinks = links.map((item) => ({
    title: item.title,
    elements: item.elements.map((item) => ({
      title: item.title,
      href: item.href,
      target: item.isTargetBlank ? '_blank' : '_self',
    })),
  }));

  const footerProps: FooterProps = {
    links: parsedLinks,
    leftSideContent: {
      copyright: {__html: leftSideContent.copyright},
      qrCodeHref: leftSideContent.qrCodeHref.data?.attributes.url,
      rustoreLogoHref: leftSideContent.rustoreLogoHref.data?.attributes.url,

      qrCodeDescription: {__html: leftSideContent.qrCodeDescription},
      socialLinks,
    },
    onLinkClick: onFooterClick,
    onSectionClick: onFooterClick,
  };

  return footerProps;
};
